import injectionCode from '../../../preview/standard-checkout'

const type = 'standard'
const path = 'client/html'
const name = 'checkout.html'
const fullPath = `${path}/${name}`

export { type, path, name, fullPath, injectionCode }
